import Icon from "assets/icons";
import { useCopies } from "shared/hooks/useCopies";
import { useEntity } from "apps/console/context/entity";
import { ConsoleRouteMap } from "apps/console/routes/routes";
import { useAuthority } from "context/authority";
import { Link, useLocation } from "react-router-dom";
import React from "react";
import { useGetActiveEntityLevel } from "../navigation/hooks";
import { EntityLevelType } from "../navigation/enum";
import { BreadCrumbConfig } from "./types";
import getProgramTypeIcon from "shared/utils/getProgramType";

export default function BreadCrumb(props: BreadCrumbConfig) {
  const copies = useCopies();
  const { setClientId, setEventSeriesId, setRegistrationId, setProgramId, programDetails } = useEntity();
  const { config } = useAuthority();
  const location = useLocation();
  const activeEntityLevel = useGetActiveEntityLevel();

  const showHomeLink = React.useMemo(
    () => config?.homePage !== location.pathname,
    [config?.homePage, location.pathname]
  );
  const programTypeIcon = React.useMemo(
    () => getProgramTypeIcon({ programType: props?.programType, programIconImage: programDetails?.icon }),
    [props?.programType, programDetails?.icon]
  );

  return (
    <div className="consoleHeaderBreadCrumb">
      <ul className="consoleHeaderBreadCrumb_list">
        {showHomeLink && (
          <li className="consoleHeaderBreadCrumb--home">
            <Link
              to={config?.homePage}
              title={copies.get("home")}
              onClick={() => {
                setClientId("");
              }}>
              <Icon.Home title={copies.get("home")} />
              <span className="consoleHeaderBreadCrumb--name">{copies.get("home")}</span>
            </Link>
          </li>
        )}
        {/*TODO: Added client name temporary `props.clientName` We need to set & call client api*/}
        {activeEntityLevel >= EntityLevelType.CLIENT && props.clientName && (
          <li className="consoleHeaderBreadCrumb--client">
            <Link
              to={ConsoleRouteMap.CLIENT.path}
              title={props.clientName}
              onClick={() => {
                setEventSeriesId("");
              }}>
              <Icon.OrgDefaultLogo title={props.clientName} />
              <span className="consoleHeaderBreadCrumb--name">{props.clientName}</span>
            </Link>
          </li>
        )}
        {activeEntityLevel >= EntityLevelType.EVENT_SERIES && (
          <li className="consoleHeaderBreadCrumb--eventSeries">
            <Link
              to={ConsoleRouteMap.EVENT_SERIES.path}
              title={props.eventSeriesName}
              onClick={() => {
                setRegistrationId("");
              }}>
              <Icon.Stadium title={props.eventSeriesName} />
              <span className="consoleHeaderBreadCrumb--name">{props.eventSeriesName}</span>
            </Link>
          </li>
        )}
        {activeEntityLevel >= EntityLevelType.REGISTRATION && (
          <li className="consoleHeaderBreadCrumb--registration">
            <Link
              to={ConsoleRouteMap.REGISTRATION.path}
              title={props.registrationName}
              onClick={() => {
                setProgramId("");
              }}>
              <Icon.Registration title={props.registrationName} />
              <span className="consoleHeaderBreadCrumb--name">{props.registrationName}</span>
            </Link>
          </li>
        )}
        {activeEntityLevel >= EntityLevelType.PROGRAM && (
          <li className="consoleHeaderBreadCrumb--program">
            <Link to={ConsoleRouteMap.PROGRAM.path} title={props.programName}>
              {programTypeIcon}
              <span className="consoleHeaderBreadCrumb--name">{props.programName}</span>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
}
